import {
  Form,
  Input,
  Button,
  DatePicker,
  Col,
  Row,
  Space,
  Select,
  InputNumber,
} from 'antd';
import Title from 'antd/lib/typography/Title';
import moment from 'moment';
import { Expense, InsertType } from '../../modules/expenses';
import { useEffect, useState } from 'react';
import TextArea from 'antd/lib/input/TextArea';

interface ExpenseEditComponentProps {
  onUpdate: (data: any) => void;
  onCancel: () => void;
  expense: Expense;
  expenseCommon: any;
}

const { Option } = Select;

function ExpenseEditComponent({
  onUpdate,
  onCancel,
  expense,
  expenseCommon,
}: ExpenseEditComponentProps) {
  const [form] = Form.useForm();
  const [mount, setMount] = useState(true);
  const [projectList, setProjectList] = useState<any[]>();
  const [gongjongList, setGongjongList] = useState<any[]>();
  const [categoryList, setCategoryList] = useState<any[]>();
  const [memberList, setMemberList] = useState<any[]>();

  useEffect(() => {
    if (!mount) return;
    let children: any = [];
    for (const project of expenseCommon.projectList.sort((a: any, b: any) =>
      b.startDate.localeCompare(a.startDate),
    )) {
      children.push(
        <Option key={project.id} value={project.id}>
          {project.name} ({project.startDate} ~ {project.endDate})
        </Option>,
      );
    }
    setProjectList(children);
    children = [];
    for (const category of expenseCommon.categoryList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={category.id} value={category.name}>
          {category.name}
        </Option>,
      );
    }
    setCategoryList(children);

    children = [];
    for (const member of expenseCommon.memberList) {
      children.push(
        <Option key={member.id} value={member.id}>
          {member.name}
        </Option>,
      );
    }
    setMemberList(children);

    children = [];
    for (const gongjong of expenseCommon.gongjongList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={gongjong.id} value={gongjong.name}>
          {gongjong.name}
        </Option>,
      );
    }
    setGongjongList(children);

    return () => setMount(false);
  }, [expenseCommon, mount]);

  let _expense: any = { ...expense };
  if (_expense.usedDateTime !== null) {
    _expense.usedDateTime = moment(
      _expense.usedDateTime,
      'YYYY-MM-DD HH:mm',
    ).add(9, 'hours');
  }

  return (
    <>
      <Row>
        <Col flex={1}>
          <Title level={3}>지출 수정</Title>
        </Col>
      </Row>
      {/* <Row justify="center"> */}
      <Form
        form={form}
        layout="vertical"
        onFinish={onUpdate}
        initialValues={_expense}
      >
        <Row>
          <Col span={24}>
            <Form.Item
              name="price"
              label="합계 금액(원)"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber
                style={{ width: '100%' }}
                formatter={(value) =>
                  `₩ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={(value) => value!.replace(/₩\s?|(,*)/g, '')}
                disabled={expense.insertType === InsertType.WITH_ASSET_DATA}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              name="vat"
              label="부가세(원)"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <InputNumber
                style={{ width: '100%' }}
                formatter={(value) =>
                  `₩ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
                parser={(value) => value!.replace(/₩\s?|(,*)/g, '')}
                disabled={expense.insertType === InsertType.WITH_ASSET_DATA}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              name="companyName"
              label="상호"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Input
                disabled={expense.insertType === InsertType.WITH_ASSET_DATA}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item name="companyAddress" label="주소">
              <Input
                disabled={expense.insertType === InsertType.WITH_ASSET_DATA}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              name="usedDateTime"
              label="사용일시"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <DatePicker
                showTime={{ format: 'HH:mm' }}
                format="YYYY-MM-DD HH:mm"
                style={{ width: '100%' }}
                disabled={expense.insertType === InsertType.WITH_ASSET_DATA}
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item name="gongjong" label="공사종류">
              <Select style={{ width: '100%' }} allowClear>
                {gongjongList}
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              name="category"
              label="용도"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: '100%' }}>{categoryList}</Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              name="isRefund"
              label="경비환급"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: '100%' }}>
                <Option value={true}>예</Option>
                <Option value={false}>아니오</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item
              name={['usedBy', 'id']}
              label="사용자"
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select style={{ width: '100%' }}>{memberList}</Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item name={['project', 'id']} label="프로젝트">
              <Select style={{ width: '100%' }}>{projectList}</Select>
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <Form.Item name="description" label="설명">
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center">
          <Form.Item>
            <Space size="middle">
              <Button htmlType="button" onClick={onCancel}>
                취소
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: '100px' }}
              >
                확인
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </Form>
      {/* </Row> */}
    </>
  );
}
export default ExpenseEditComponent;
